import React, { useState } from 'react';
import { TbLibraryPhoto } from "react-icons/tb";
import { LuFullscreen } from "react-icons/lu";
import { FaRegCirclePlay } from "react-icons/fa6";
import { FaChevronLeft } from "react-icons/fa";
import { FaChevronRight } from "react-icons/fa";
// import Image27 from '../../../assest/farmstay/27.jpeg'
// import Image31 from '../../../assest/farmstay/31.jpeg'
// import Image32 from '../../../assest/farmstay/32.jpeg'
// import Image33 from '../../../assest/farmstay/33.jpeg'
// import Image34 from '../../../assest/farmstay/34.jpeg'
// import Image35 from '../../../assest/farmstay/35.jpeg'
// import Image36 from '../../../assest/farmstay/36.jpeg'
// import Image37 from '../../../assest/farmstay/37.jpeg'
// import Image38 from '../../../assest/farmstay/38.jpeg'
// import Image39 from '../../../assest/farmstay/39.jpeg'
// import Image40 from '../../../assest/farmstay/40.jpeg'
// import Image41 from '../../../assest/farmstay/41.jpeg'
// import Image42 from '../../../assest/farmstay/42.jpeg'
// import Image43 from '../../../assest/farmstay/43.jpeg'
// import Image45 from '../../../assest/farmstay/45.jpeg'
// import Image46 from '../../../assest/farmstay/46.jpeg'
// import Image47 from '../../../assest/farmstay/47.jpeg'
// import Image49 from '../../../assest/farmstay/49.jpeg'
// import Image50 from '../../../assest/farmstay/50.jpeg'
// import Image52 from '../../../assest/farmstay/52.jpeg'
// import Image53 from '../../../assest/farmstay/53.jpeg'
// import Image55 from '../../../assest/farmstay/55.jpeg'
// import Image56 from '../../../assest/farmstay/56.jpg'
// import Image57 from '../../../assest/farmstay/57.jpg'
// import Image58 from '../../../assest/farmstay/58.jpg'
// import Image59 from '../../../assest/farmstay/59.jpg'
// import Image60 from '../../../assest/farmstay/60.jpg'
// import Image61 from '../../../assest/farmstay/61.jpg'
// import Image62 from '../../../assest/farmstay/62.jpg'
// import Image63 from '../../../assest/farmstay/63.jpg'
// import Image64 from '../../../assest/farmstay/64.jpg'
// import Image65 from '../../../assest/farmstay/65.jpg'
// import Image66 from '../../../assest/farmstay/66.jpg'
// import Image67 from '../../../assest/farmstay/67.jpg'
// import Image68 from '../../../assest/farmstay/68.jpg'
// import Image69 from '../../../assest/farmstay/69.jpg'
// import Image70 from '../../../assest/farmstay/70.jpg'
// import Image71 from '../../../assest/farmstay/71.jpg'
// import Image72 from '../../../assest/farmstay/72.jpg'
// import Image73 from '../../../assest/farmstay/73.jpg'
// import Image74 from '../../../assest/farmstay/74.jpg'
// import Image75 from '../../../assest/farmstay/75.jpg'
// import Image76 from '../../../assest/farmstay/76.jpg'
// import Image77 from '../../../assest/farmstay/77.jpg'
// import Image78 from '../../../assest/farmstay/78.jpg'
// import Image79 from '../../../assest/farmstay/79.jpg'
// import Image80 from '../../../assest/farmstay/80.jpg'
// import Image81 from '../../../assest/farmstay/81.jpg'
// import Image82 from '../../../assest/farmstay/82.jpg'
// import Image83 from '../../../assest/farmstay/83.jpg'
// import Image84 from '../../../assest/farmstay/84.jpg'
// import Image85 from '../../../assest/farmstay/85.jpg'
// import Image86 from '../../../assest/farmstay/86.jpg'
// import Image87 from '../../../assest/farmstay/87.jpeg'
// import Image88 from '../../../assest/farmstay/88.jpeg'
// import Image89 from '../../../assest/farmstay/89.jpeg'
// import Image90 from '../../../assest/farmstay/90.jpeg'
// import Image91 from '../../../assest/farmstay/91.jpeg'
// import Image92 from '../../../assest/farmstay/92.jpeg'
// import Image93 from '../../../assest/farmstay/93.jpeg'
// import Image94 from '../../../assest/farmstay/94.jpeg'
// import Image95 from '../../../assest/farmstay/95.jpeg'
// import Image96 from '../../../assest/farmstay/96.jpeg'
// import Image97 from '../../../assest/farmstay/97.jpeg'
// import Image98 from '../../../assest/farmstay/98.jpeg'
// import Image99 from '../../../assest/farmstay/99.jpeg'
// import Image100 from '../../../assest/farmstay/100.jpeg'
// import Image101 from '../../../assest/farmstay/101.jpeg'
// import Image102 from '../../../assest/farmstay/102.jpeg'
// import Image103 from '../../../assest/farmstay/103.jpeg'
// import Image104 from '../../../assest/farmstay/104.jpeg'
// import Video1 from '../../../assest/farmstay/video.mp4'
// import Video2 from '../../../assest/farmstay/video2.mp4'
import Image1 from '../../../assest/farm/1.jpeg'
import Image2 from '../../../assest/farm/2.jpeg'
import Image3 from '../../../assest/farm/3.jpeg'
import Image4 from '../../../assest/farm/4.jpeg'
import Image5 from '../../../assest/farm/5.jpeg'
import Image6 from '../../../assest/farm/6.jpeg'
import Image7 from '../../../assest/farm/7.jpeg'
import Image8 from '../../../assest/farm/8.jpeg'
import Image9 from '../../../assest/farm/9.jpeg'
import Image10 from '../../../assest/farm/10.jpeg'
import Image11 from '../../../assest/farm/11.jpeg'
import Image12 from '../../../assest/farm/12.jpeg'
import Image13 from '../../../assest/farm/13.jpeg'
import Image14 from '../../../assest/farm/14.jpeg'
import Image15 from '../../../assest/farm/15.jpeg'
import Image16 from '../../../assest/farm/16.jpeg'
import Image17 from '../../../assest/farm/17.jpeg'
import Image18 from '../../../assest/farm/18.jpeg'
import Image19 from '../../../assest/farm/19.jpeg'
import Image20 from '../../../assest/farm/20.jpeg'
import Image21 from '../../../assest/farm/21.jpeg'
import './housedetailsgallery.scss';

const HouseDetailsGallery = () => {

	const galleryItems = [
		{
			id: 21,
			type: 'image',
			src: Image21,
			thumbnail: Image21
		},
		{
			id: 1,
			type: 'image',
			src: Image1,
			thumbnail: Image1
		},
		{
			id: 2,
			type: 'image',
			src: Image2,
			thumbnail: Image2
		},
		{
			id: 3,
			type: 'image',
			src: Image3,
			thumbnail: Image3
		},
		{
			id: 4,
			type: 'image',
			src: Image4,
			thumbnail: Image4
		},
		{
			id: 5,
			type: 'image',
			src: Image5,
			thumbnail: Image5
		},
		{
			id: 6,
			type: 'image',
			src: Image6,
			thumbnail: Image6
		},
		{
			id: 7,
			type: 'image',
			src: Image7,
			thumbnail: Image7
		},
		{
			id: 8,
			type: 'image',
			src: Image8,
			thumbnail: Image8
		},
		{
			id: 9,
			type: 'image',
			src: Image9,
			thumbnail: Image9
		},
		{
			id: 10,
			type: 'image',
			src: Image10,
			thumbnail: Image10
		},
		{
			id: 11,
			type: 'image',
			src: Image11,
			thumbnail: Image11
		},
		{
			id: 12,
			type: 'image',
			src: Image12,
			thumbnail: Image12
		},
		{
			id: 13,
			type: 'image',
			src: Image13,
			thumbnail: Image13
		},
		{
			id: 14,
			type: 'image',
			src: Image14,
			thumbnail: Image14
		},
		{
			id: 15,
			type: 'image',
			src: Image15,
			thumbnail: Image15
		},
		{
			id: 16,
			type: 'image',
			src: Image16,
			thumbnail: Image16
		},
		{
			id: 17,
			type: 'image',
			src: Image17,
			thumbnail: Image17
		},
		{
			id: 18,
			type: 'image',
			src: Image18,
			thumbnail: Image18
		},
		{
			id: 19,
			type: 'image',
			src: Image19,
			thumbnail: Image19
		},
		{
			id: 20,
			type: 'image',
			src: Image20,
			thumbnail: Image20
		}
	];
	const [isPopupOpen, setIsPopupOpen] = useState(false);
	const [activeIndex, setActiveIndex] = useState(0); // Start with the first item
	const currentItem = galleryItems[activeIndex];

	const handleThumbnailClick = (index) => {
		setActiveIndex(index);
	};

	const handleNext = () => {
		setActiveIndex((prevIndex) => (prevIndex + 1) % galleryItems.length);
	};

	const handlePrev = () => {
		setActiveIndex((prevIndex) => (prevIndex - 1 + galleryItems.length) % galleryItems.length);
	};

	const openPopup = () => {
		setIsPopupOpen(true);
	};

	const closePopup = () => {
		setIsPopupOpen(false);
	};

	return (
		<>
			<section className="gallery-section">
				<div className="main-gallery-view">
					{currentItem.type === 'image' ? (
						<img
							src={currentItem.src}
							alt="Interior"
							onClick={openPopup}
							style={{ cursor: "pointer" }}
						/>
					) : (
						// <video controls src={currentItem.src} poster={currentItem.thumbnail}></video>
						<iframe
							className="video-frame"
							src={currentItem.src}
							title="Video"
							style={{ border: "none" }}
							allowFullScreen={true}
						/>
					)}
					<div className="gallery-nav">
						<button className="nav-btn" onClick={handlePrev}><FaChevronLeft className="material-symbols-outlined" /></button>
						<button className="nav-btn" onClick={handleNext}><FaChevronRight className="material-symbols-outlined" /></button>
					</div>
					<div className="gallery-badges">
						<div className="glass-panel count-badge">
							<TbLibraryPhoto className="material-symbols-outlined" /> {galleryItems.filter(item => item.type === 'image').length} Photos + {galleryItems.filter(item => item.type === 'video').length} Videos
						</div>
						<button className="full-btn glass-panel"><LuFullscreen className="material-symbols-outlined" /></button>
					</div>
				</div>

				<div className="HouseDetailsGallerythumbnails">
					{galleryItems.map((item, index) => (
						<div
							key={item.id}
							className={`HouseDetailsGallerythumb ${index === activeIndex ? 'active' : ''} ${item.type === 'video' ? 'video-thumb' : ''}`}
							onClick={() => handleThumbnailClick(index)}
						>
							<img src={item.thumbnail} alt={`HouseDetailsGallerythumb ${index}`} />

							{item.type === 'video' && (
								<div className="video-play-overlay">
									<FaRegCirclePlay className="play-icon" />
								</div>
							)}
						</div>
					))}
				</div>

				{isPopupOpen && (
					<div className="gallery-popup">
						<div className="popup-overlay" onClick={closePopup}>

							<div className="popup-content" onClick={(e) => e.stopPropagation()}>
								<button className="close-btn" onClick={closePopup}>×</button>

								<div className="popup-content-omg">

									<button className="nav-btn left" onClick={handlePrev}>
										<FaChevronLeft />
									</button>

									<div className='ImageShowing'>
										<img src={currentItem.src} alt="popup" />
										<div className="image-count">
											{activeIndex + 1} / {galleryItems.length}
										</div>
									</div>

									<button className="nav-btn right" onClick={handleNext}>
										<FaChevronRight />
									</button>
								</div>

							</div>
						</div>
					</div>
				)}
			</section>
		</>
	);
};

export default HouseDetailsGallery;
